var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagTurksAndCaicos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.8516C32 25.6881 24.8365 32.8516 16 32.8516C7.1635 32.8516 0 25.6881 0 16.8516C0 16.8554 16 0.853313 16 0.851562C24.8365 0.851562 32 8.01506 32 16.8516Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 16.8514H16C16 16.837 16 16.823 16 16.8086C15.9857 16.8229 15.9715 16.8372 15.9572 16.8514Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.19938C16 6.38406 16 4.53938 16 0.851562H15.9973C7.16194 0.853063 0 8.01587 0 16.8516H8.34781V12.1509L13.0485 16.8516H15.9572C15.9715 16.8373 15.9858 16.8231 16.0001 16.8088C16.0001 15.7308 16.0001 14.769 16.0001 13.9002L11.2992 9.19938H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09469 2.93848C5.59226 4.36341 3.51182 6.44379 2.08694 8.94623V16.8515H6.26088V7.11254V7.11241H16C16 5.79598 16 4.54185 16 2.93848H8.09469Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.8838L10.3153 9.19922H8.34781V9.19934L15.9999 16.8513H16C16 16.8513 16 15.4947 16 14.8838Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 9.19922V16.8513C18.0869 20.5788 22.9565 21.721 22.9565 21.721C22.9565 21.721 27.8261 20.5788 27.8261 16.8513V9.19922H18.0869Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2611 11.9821C22.2611 12.7506 21.6383 14.7648 20.8698 14.7648C20.1014 14.7648 19.4785 12.7506 19.4785 11.9821C19.4785 11.2137 20.8698 10.5908 20.8698 10.5908C20.8698 10.5908 22.2611 11.2137 22.2611 11.9821Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9528 13.4974C26.1773 12.9496 26.3519 12.1489 26.3519 11.7503C26.3519 11.1099 25.5171 10.5908 25.5171 10.5908C25.5171 10.5908 24.6823 11.1099 24.6823 11.7503C24.6823 12.1489 24.8569 12.9496 25.0814 13.4974L24.5995 14.5856C24.8827 14.7007 25.1924 14.7647 25.517 14.7647C25.8417 14.7647 26.1514 14.7007 26.4346 14.5856L25.9528 13.4974Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9134 16.8514C21.9134 16.8514 21.2178 18.2427 21.2178 19.634H24.696C24.696 18.2427 24.0003 16.8514 24.0003 16.8514L22.9568 16.1558L21.9134 16.8514Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16.8518V16.5039C24 15.9277 23.5328 15.4604 22.9565 15.4604C22.3802 15.4604 21.913 15.9276 21.913 16.5039V16.8518H24Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.851562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTurksAndCaicos);
export default __webpack_public_path__ + "static/media/flag_turks_and_caicos.b361aa52cec493b8697b4b45bb43b4bc.svg";
export { ForwardRef as ReactComponent };